export const MODIFY_REQUIRED_FIELD_LIST = 'checkout-modify-required-field-list';

export default function modifyRequiredFieldList({ add, remove }) {
  const addedFields = Array.isArray(add) ? add : [add];
  const removedFields = Array.isArray(remove) ? remove : [remove];

  return {
    type: MODIFY_REQUIRED_FIELD_LIST,
    payload: {
      addedFields,
      removedFields,
    },
  };
}
